export default {"src":"/_next/static/media/alarm-clock.12791725.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};